import { AppContextProps } from '../../hooks/useApp'
import { SystemControl } from '../SystemControl'
import { BatteryStateWidget } from './BatteryStateWidget'
import { ConsumptionStatWidget } from './ComsumptionStatWidget'
import { PowerGraphWidget } from './PowerGraph'
import { PriceGraphWidget } from './PriceGraph'
import { PriceStatWidget } from './PriceStatWidget'
import { ProductionStatWidget } from './ProductionStatWidget'
import { RelayBarWidget } from './RelayBarWidget'
import { TemperatureStatWidget } from './TemperatureStatWidget'
import { HeatPumpStateWidget } from './HeatPumpStateWidget'
import { WidgetConfig, WidgetData, WidgetType, Widget } from './Widget'

const WidgetTypes: Record<WidgetType, typeof Widget<{}, WidgetConfig>> = {
  BATTERY_STATE: BatteryStateWidget,
  COMSUMPTION_STAT: ConsumptionStatWidget,
  PRODUCTION_STAT: ProductionStatWidget,
  POWER_GRAPH: PowerGraphWidget,
  PRICE_GRAPH: PriceGraphWidget,
  RELAY_BAR: RelayBarWidget,
  PRICE_STAT: PriceStatWidget,
  TEMPERATURE_STAT: TemperatureStatWidget,
  HEAT_PUMP_STATE: HeatPumpStateWidget,
}

/**
 * Instantiate a widget for the given data.
 */
export function getWidget(data: WidgetData, control: SystemControl, app: AppContextProps) {
  if (!WidgetTypes[data.type]) {
    throw new Error(`Invalid widget type '${data.type}'.`)
  }
  return new WidgetTypes[data.type](data, control, app)
}
